/* eslint-disable no-undef */
import React, { useEffect, useState } from "react";
import UserSidebar from "../../Component/UserSidebar";
import { Link } from "react-router-dom";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import * as userAction from "../../actions/userActions";
import { useForm } from "react-hook-form";
import { Row, Col, Form } from "react-bootstrap";
import Button from "../../Component/Button";
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import PopupModalWithOk from "../../utils/helpers/popupModalOk";
import PropTypes from "prop-types";

function SidebarAddClass() {
  const el = document.getElementById("OnscrollBody");
  if (el?.classList) {
    el.classList.toggle("show_sidebar");
  }
}

function SidebarRemoveClass() {
  const el = document.getElementById("OnscrollBody");
  if (el?.classList) {
    el.classList.remove("show_sidebar");
  }
}

const Index = (props) => {
  const { title, userInfo, actions } = props;
  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
  } = useForm();

  const [showPassword, setShowPassword] = useState(true);
  const [showPassword1, setShowPassword1] = useState(true);
  const [showPassword2, setShowPassword2] = useState(true);
  const [showPopup, setShowPopup] = useState(false);
  const [popupMessage, setPopupMessage] = useState("");

  useEffect(() => {
    document.title = title;
  }, [title]);

  const onSubmit = async (data) => {
    data.id = userInfo.id;
    const result = await actions.updatePasswordData(data);
    if (result?.message) {
      setPopupMessage(result.message);
      setShowPopup(true);
    }
  };

  const handlePasswordPopupClose = () => {
    setShowPopup(false);
    // redirect only after user clicks OK
    globalThis.location.href = "/login";
  };

  const newPassword = watch('password');
  const conNewPassword = watch('password_confirmation');
  const conditionCheck = newPassword != conNewPassword && !errors.password_confirmation;

  const togglePasswordVisibility = () => {
    setShowPassword((prevState) => !prevState);
  };

  const togglePasswordVisibility1 = () => {
    setShowPassword1((prevState) => !prevState);
  };

  const togglePasswordVisibility2 = () => {
    setShowPassword2((prevState) => !prevState);
  };

  return (
    <div>
      <div className="dashboard_outer">
        <UserSidebar />
        <div className="dashboard_inner">
          <div className="d-block mb-3 mb-md-0 mb-md-none toggle_btn_outer">
            <Link
              to="#"
              onClick={SidebarAddClass}
              className="toggle_btn d-lg-none"
            >
              <i className="fas fa-bars"></i>
            </Link>
          </div>

          <h2 className="page_heading mb-3">Change Password</h2>

          <div className="box shadow bg-white p-4">
            <div className="studentformdashboard">
              <Form onSubmit={handleSubmit(onSubmit)}>
                <Row>
                  <Col md={12}>
                    <Row className="align-items-center">
                      <Col sm={12}>
                        <Row>
                          <Col sm={12}>
                            <div className="form-group">
                              <label className="form-label" htmlFor="current">Current Password*</label>
                              <div style={{ position: 'relative' }}>
                                <Form.Control
                                  type={showPassword ? "password" : "text"}
                                  style={{ paddingRight: '43px' }}
                                  className='form-control'
                                  name="current_password"
                                  aria-invalid={errors?.current_password ? "true" : "false"}
                                  {...register("current_password", {
                                    required: true,
                                    minLength: 6,
                                    pattern: {
                                      value: /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{6,64}$/,
                                    },
                                  })}
                                />
                                <button
                                  type="button"
                                  onClick={togglePasswordVisibility}
                                  style={{ all: "unset", cursor: "pointer", position: "absolute", right: "16px", top: "50%", transform: "translateY(-50%)" }}
                                >
                                  {showPassword ? <FaEyeSlash /> : <FaEye />}
                                </button>
                              </div>
                              {errors?.current_password &&
                                errors?.current_password?.type === "required" && (
                                  <label style={{ fontSize: "14px", color: 'red' }} htmlFor="current">
                                    Please enter your current password
                                  </label>
                                )}
                              {errors?.current_password &&
                                errors?.current_password?.type === "minLength" && (
                                  <label style={{ fontSize: "14px", color: 'red' }} htmlFor="current">
                                    Your password should contain at least 6 characters
                                  </label>
                                )}
                              {errors?.current_password &&
                                errors?.current_password?.type === "pattern" && (
                                  <label style={{ fontSize: "14px", color: 'red' }} htmlFor="current">
                                    Password must have a minimum of 6 characters. It must be a combination of numerals, alphabet and special characters.
                                  </label>
                                )}
                            </div>
                          </Col>

                          <Col sm={12}>
                            <div className="form-group">
                              <label className="form-label" htmlFor="password">New Password*</label>
                              <div style={{ position: 'relative' }}>
                                <Form.Control
                                  type={showPassword1 ? "password" : "text"}
                                  className="form-control"
                                  name="password"
                                  aria-invalid={errors?.password ? "true" : "false"}
                                  {...register("password", {
                                    required: true,
                                    minLength: 6,
                                    pattern: {
                                      value: /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{6,64}$/,
                                    },
                                  })}
                                />
                                <button
                                  type="button"
                                  className="password-toggle-icon"
                                  onClick={togglePasswordVisibility1}
                                  style={{ all: "unset", cursor: "pointer", position: "absolute", right: "16px", top: "50%", transform: "translateY(-50%)" }}
                                >
                                  {showPassword1 ? <FaEyeSlash /> : <FaEye />}
                                </button>
                              </div>
                              {errors?.password && errors?.password?.type === "required" && (
                                <label style={{ fontSize: "14px", color: 'red' }} htmlFor="password">
                                  Please enter your password
                                </label>
                              )}
                              {errors?.password && errors?.password?.type === "minLength" && (
                                <label style={{ fontSize: "14px", color: 'red' }} htmlFor="password">
                                  Your password should contain at least 6 characters
                                </label>
                              )}
                              {errors?.password && errors?.password?.type === "pattern" && (
                                <label style={{ fontSize: "14px", color: 'red' }} htmlFor="password">
                                  Your password should contain at-least 1 Uppercase, 1 Lowercase, 1 Numeric and 1 special character
                                </label>
                              )}
                            </div>
                          </Col>

                          <Col sm={12}>
                            <div className="form-group">
                              <label className="form-label" htmlFor="password_confirmation">Confirm Password*</label>
                              <div style={{ position: 'relative' }}>
                                <Form.Control
                                  type={showPassword2 ? "password" : "text"}
                                  className="form-control"
                                  name="password_confirmation"
                                  aria-invalid={errors?.password_confirmation ? "true" : "false"}
                                  {...register("password_confirmation", {
                                    required: true,
                                    minLength: 6,
                                    maxLength: 15,
                                    pattern: {
                                      value: /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{6,64}$/,
                                    },
                                  })}
                                />
                                <button
                                  type="button"
                                  className="password-toggle-icon"
                                  onClick={togglePasswordVisibility2}
                                  style={{ all: "unset", cursor: "pointer", position: "absolute", right: "16px", top: "50%", transform: "translateY(-50%)" }}
                                >
                                  {showPassword2 ? <FaEyeSlash /> : <FaEye />}
                                </button>
                              </div>
                              {errors?.password_confirmation && errors?.password_confirmation?.type === "required" && (
                                <label style={{ fontSize: "14px", color: 'red' }} htmlFor="password_confirmation">
                                  Please enter your confirmation password
                                </label>
                              )}
                              {errors?.password_confirmation && errors?.password_confirmation?.type === "minLength" && (
                                <label style={{ fontSize: "14px", color: 'red' }} htmlFor="password_confirmation">
                                  Your password should contain at least 6 characters
                                </label>
                              )}
                              {errors?.password_confirmation && errors?.password_confirmation?.type === "pattern" && (
                                <label style={{ fontSize: "14px", color: 'red' }} htmlFor="password_confirmation">
                                  Your password should contain at-least 1 Uppercase, 1 Lowercase, 1 Numeric and 1 special character
                                </label>
                              )}
                              {conditionCheck && (
                                <label className="text-left" style={{ color: 'red', fontSize: '0.875em', marginTop: '0.25rem' }} htmlFor="password_confirmation">
                                  New password and confirm password does not match
                                </label>
                              )}
                            </div>
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  </Col>

                  <Col sm={12}>
                    <Row>
                      <Col md={12}>
                        <div className="form-group mt-3 text-left">
                          <Button
                            title={"Submit"}
                            type='submit'
                            className={"btn loginsubmit nextbtn ml-2"}
                          />
                        </div>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </Form>
            </div>
          </div>
        </div>
      </div>
      <button type="button" className="sidebar_overlay" onClick={SidebarRemoveClass}></button>

      <PopupModalWithOk
        show={showPopup}
        onHide={handlePasswordPopupClose}
        message={popupMessage}
        showConfirm={false}
        staticBackdrop={true}
      />

    </div>
  );
};

Index.propTypes = {
  title: PropTypes.string.isRequired,
  userInfo: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  }).isRequired,
  actions: PropTypes.shape({
    updatePasswordData: PropTypes.func.isRequired,
  }).isRequired,
};

function mapStateToProps(state) {
  return {
    userInfo: state.userInfo,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...userAction }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Index);
